import React, { useState } from 'react';
import { TrendingUp, Clock, BarChart3, Wallet, CreditCard, Plus, AlertCircle, ArrowDownToLine } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
interface FinancesTabProps {
  showToast: (msg: string) => void;
}
export function FinancesTab({
  showToast
}: FinancesTabProps) {
  const [addingCard, setAddingCard] = useState(false);
  return <div className="space-y-6" data-id="element-11814">
      <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-11815">Финансы</h2>

      {/* Section 1: Balance Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-11816">
        <Card padding="md" className="bg-slate-900 text-white border-none flex flex-col justify-between" data-id="element-11817">
          <div data-id="element-11818">
            <div className="text-slate-400 text-sm mb-1" data-id="element-11819">Доступно к выводу</div>
            <div className="text-3xl font-bold mb-4" data-id="element-11820">24 500 ₽</div>
          </div>
          <Button variant="primary" fullWidth size="sm" onClick={() => showToast('Заявка на вывод отправлена ✓')} data-id="element-11821">
            Вывести средства
          </Button>
        </Card>
        <Card padding="md" className="flex flex-col justify-between" data-id="element-11822">
          <div data-id="element-11823">
            <div className="text-slate-500 text-sm mb-1" data-id="element-11824">
              Заработано за месяц
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-4" data-id="element-11825">
              48 000 ₽
            </div>
          </div>
          <div className="text-sm text-emerald-600 flex items-center font-medium" data-id="element-11826">
            <TrendingUp className="w-4 h-4 mr-1" data-id="element-11827" /> +12% к прошлому месяцу
          </div>
        </Card>
        <Card padding="md" className="flex flex-col justify-between" data-id="element-11828">
          <div data-id="element-11829">
            <div className="text-slate-500 text-sm mb-1" data-id="element-11830">В ожидании</div>
            <div className="text-3xl font-bold text-slate-900 mb-4" data-id="element-11831">
              9 000 ₽
            </div>
          </div>
          <div className="text-sm text-slate-500 flex items-center" data-id="element-11832">
            <Clock className="w-4 h-4 mr-1 text-amber-500" data-id="element-11833" /> 2 заказа в работе
          </div>
        </Card>
        <Card padding="md" className="flex flex-col justify-between" data-id="element-11834">
          <div data-id="element-11835">
            <div className="text-slate-500 text-sm mb-1" data-id="element-11836">Всего заработано</div>
            <div className="text-3xl font-bold text-slate-900 mb-4" data-id="element-11837">
              324 500 ₽
            </div>
          </div>
          <div className="text-sm text-slate-500 flex items-center" data-id="element-11838">
            <BarChart3 className="w-4 h-4 mr-1 text-indigo-500" data-id="element-11839" /> За всё время
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-11840">
        {/* Section 2: Способ вывода */}
        <Card padding="md" data-id="element-11841">
          <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-11842">
            <Wallet className="w-5 h-5 text-indigo-500" data-id="element-11843" /> Способ вывода средств
          </h3>

          <div className="bg-slate-50 border border-slate-100 rounded-xl p-4 mb-4" data-id="element-11844">
            <div className="flex items-center justify-between" data-id="element-11845">
              <div className="flex items-center gap-3" data-id="element-11846">
                <div className="w-10 h-10 bg-white rounded-lg shadow-sm flex items-center justify-center border border-slate-100" data-id="element-11847">
                  <CreditCard className="w-5 h-5 text-slate-700" data-id="element-11848" />
                </div>
                <div data-id="element-11849">
                  <div className="font-bold text-slate-900" data-id="element-11850">Visa •••• 4276</div>
                  <div className="text-xs text-slate-500" data-id="element-11851">Сбербанк</div>
                </div>
              </div>
              <Badge variant="success" data-id="element-11852">Основная</Badge>
            </div>
          </div>

          {addingCard ? <div className="bg-white border border-indigo-100 rounded-xl p-4 mb-4 shadow-sm" data-id="element-11853">
              <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-11854">
                Добавление новой карты
              </h4>
              <div className="space-y-3" data-id="element-11855">
                <Input label="Номер карты" placeholder="0000 0000 0000 0000" data-id="element-11856" />
                <Input label="Имя владельца" placeholder="IVAN IVANOV" data-id="element-11857" />
                <div className="flex gap-2 pt-2" data-id="element-11858">
                  <Button variant="outline" size="sm" onClick={() => setAddingCard(false)} fullWidth data-id="element-11859">
                    Отмена
                  </Button>
                  <Button variant="primary" size="sm" onClick={() => {
                setAddingCard(false);
                showToast('Карта успешно добавлена ✓');
              }} fullWidth data-id="element-11860">
                    Сохранить
                  </Button>
                </div>
              </div>
            </div> : <div className="flex gap-2 mb-4" data-id="element-11861">
              <Button variant="outline" size="sm" className="flex-1" onClick={() => showToast('Редактирование карты...')} data-id="element-11862">
                Изменить
              </Button>
              <Button variant="outline" size="sm" className="flex-1" icon={<Plus className="w-4 h-4" data-id="element-11864" />} onClick={() => setAddingCard(true)} data-id="element-11863">
                Добавить карту
              </Button>
            </div>}

          <p className="text-xs text-slate-500 flex items-start gap-1.5" data-id="element-11865">
            <AlertCircle className="w-3.5 h-3.5 text-slate-400 flex-shrink-0 mt-0.5" data-id="element-11866" />
            Комиссия за вывод: 0%. Срок зачисления: 1-3 рабочих дня. Минимальная
            сумма вывода: 1 000 ₽.
          </p>
        </Card>

        {/* Section 3: Доход по услугам */}
        <Card padding="md" data-id="element-11867">
          <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-11868">
            <BarChart3 className="w-5 h-5 text-indigo-500" data-id="element-11869" /> Доход по услугам
          </h3>

          <div className="space-y-4" data-id="element-11870">
            {[{
            name: 'Натальная карта',
            amount: '210 000 ₽',
            percent: 100,
            color: 'bg-indigo-500'
          }, {
            name: 'Соляр на год',
            amount: '112 000 ₽',
            percent: 53,
            color: 'bg-indigo-400'
          }, {
            name: 'Синастрия',
            amount: '90 000 ₽',
            percent: 43,
            color: 'bg-indigo-300'
          }, {
            name: 'Товары',
            amount: '44 550 ₽',
            percent: 21,
            color: 'bg-indigo-200'
          }].map((item, i) => <div key={i} data-id="element-11871">
                <div className="flex justify-between text-sm mb-1.5" data-id="element-11872">
                  <span className="font-medium text-slate-700" data-id="element-11873">
                    {item.name}
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-11874">
                    {item.amount}
                  </span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-11875">
                  <div className={`h-2 rounded-full ${item.color}`} style={{
                width: `${item.percent}%`
              }} data-id="element-11876"></div>
                </div>
              </div>)}
          </div>
        </Card>
      </div>

      {/* Section 4: История транзакций */}
      <Card padding="none" className="overflow-hidden" data-id="element-11877">
        <div className="p-4 sm:p-6 border-b border-slate-100 flex justify-between items-center" data-id="element-11878">
          <h3 className="font-bold text-slate-900" data-id="element-11879">История транзакций</h3>
          <Button variant="ghost" size="sm" icon={<ArrowDownToLine className="w-4 h-4" data-id="element-11881" />} onClick={() => showToast('Выписка скачивается...')} data-id="element-11880">
            Скачать выписку
          </Button>
        </div>

        {/* Desktop Table */}
        <div className="hidden sm:block overflow-x-auto" data-id="element-11882">
          <table className="w-full text-left text-sm" data-id="element-11883">
            <thead className="bg-slate-50 text-slate-500" data-id="element-11884">
              <tr data-id="element-11885">
                <th className="px-6 py-4 font-medium" data-id="element-11886">Дата</th>
                <th className="px-6 py-4 font-medium" data-id="element-11887">Тип</th>
                <th className="px-6 py-4 font-medium" data-id="element-11888">Описание</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-11889">Сумма</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-11890">
              {[{
              date: '15 Окт 2024',
              type: 'Доход',
              desc: 'Заказ #1042 — Натальная карта',
              amount: '+5 000 ₽',
              isIncome: true
            }, {
              date: '14 Окт 2024',
              type: 'Доход',
              desc: 'Заказ #1041 — Синастрия',
              amount: '+6 000 ₽',
              isIncome: true
            }, {
              date: '10 Окт 2024',
              type: 'Вывод',
              desc: 'На карту •••• 4276',
              amount: '-32 000 ₽',
              isIncome: false
            }, {
              date: '01 Окт 2024',
              type: 'Доход',
              desc: 'Заказ #1030 — Натальная карта',
              amount: '+5 000 ₽',
              isIncome: true
            }, {
              date: '28 Сен 2024',
              type: 'Доход',
              desc: 'Товар — Вебинар Меркурий',
              amount: '+990 ₽',
              isIncome: true
            }, {
              date: '15 Сен 2024',
              type: 'Вывод',
              desc: 'На карту •••• 4276',
              amount: '-28 500 ₽',
              isIncome: false
            }].map((tx, i) => <tr key={i} className="hover:bg-slate-50/50 transition-colors" data-id="element-11891">
                  <td className="px-6 py-4 text-slate-500 whitespace-nowrap" data-id="element-11892">
                    {tx.date}
                  </td>
                  <td className="px-6 py-4" data-id="element-11893">
                    <Badge variant={tx.isIncome ? 'success' : 'neutral'} className={!tx.isIncome ? 'bg-slate-100 text-slate-600' : ''} data-id="element-11894">
                      {tx.type}
                    </Badge>
                  </td>
                  <td className="px-6 py-4 text-slate-700" data-id="element-11895">{tx.desc}</td>
                  <td className={`px-6 py-4 text-right font-bold whitespace-nowrap ${tx.isIncome ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-11896">
                    {tx.amount}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile List */}
        <div className="sm:hidden divide-y divide-slate-100" data-id="element-11897">
          {[{
          date: '15 Окт 2024',
          type: 'Доход',
          desc: 'Заказ #1042 — Натальная карта',
          amount: '+5 000 ₽',
          isIncome: true
        }, {
          date: '14 Окт 2024',
          type: 'Доход',
          desc: 'Заказ #1041 — Синастрия',
          amount: '+6 000 ₽',
          isIncome: true
        }, {
          date: '10 Окт 2024',
          type: 'Вывод',
          desc: 'На карту •••• 4276',
          amount: '-32 000 ₽',
          isIncome: false
        }, {
          date: '01 Окт 2024',
          type: 'Доход',
          desc: 'Заказ #1030 — Натальная карта',
          amount: '+5 000 ₽',
          isIncome: true
        }, {
          date: '28 Сен 2024',
          type: 'Доход',
          desc: 'Товар — Вебинар Меркурий',
          amount: '+990 ₽',
          isIncome: true
        }, {
          date: '15 Сен 2024',
          type: 'Вывод',
          desc: 'На карту •••• 4276',
          amount: '-28 500 ₽',
          isIncome: false
        }].map((tx, i) => <div key={i} className="p-4 flex justify-between items-center gap-3" data-id="element-11898">
              <div className="min-w-0" data-id="element-11899">
                <div className="font-medium text-slate-900 text-sm truncate mb-1" data-id="element-11900">
                  {tx.desc}
                </div>
                <div className="flex items-center gap-2 text-xs text-slate-500" data-id="element-11901">
                  <span data-id="element-11902">{tx.date}</span>
                  <span data-id="element-11903">•</span>
                  <span className={tx.isIncome ? 'text-emerald-600' : 'text-slate-500'} data-id="element-11904">
                    {tx.type}
                  </span>
                </div>
              </div>
              <div className={`font-bold whitespace-nowrap ${tx.isIncome ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-11905">
                {tx.amount}
              </div>
            </div>)}
        </div>
      </Card>
    </div>;
}